// extracted by mini-css-extract-plugin
module.exports = {"containerButtons":"CompanyAccount_containerButtons__2kcB-","form":"CompanyAccount_form__9F2wh"};